import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'rock',
      d: 'M-2.5,-1.5h2.5v0.5h-2.5zM0.5,-1.5h2.5v0.5h-2.5zM-3,-1h1v0.5h-1zM-0.5,-1h1.5v0.5h-1.5zM2.5,-1h0.5v0.5h-0.5zM0,-0.5h1.5v0.5h-1.5zM-0.5,0h1v0.5h-1zM-2,0.5h2v0.5h-2z',
    },
    {
      paint: 'tidePools',
      d: 'M-2,-1h1.5v0.5h-1.5zM1,-1h1.5v0.5h-1.5zM-2.5,-0.5h2.5v0.5h-2.5zM1.5,-0.5h0.5v0.5h-0.5zM-2,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'boulder',
      d: 'M-3,-0.5h0.5v0.5h-0.5zM2,-0.5h1v0.5h-1zM-3,0h1v0.5h-1zM1,0h1.5v0.5h-1.5zM-2.5,0.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 49,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
